<div id="main" class="internal">
  <div id="home" class="section home-ristoranti">
    <div class="content-body">
      <div class="big-button" (click)="goTo('crea')">
        <div class="img-button">
          <div class="icon">
            <i class="pi pi-plus" style="font-size: 2.5rem"></i>
          </div>
        </div>
        <button class="costa-button">
          {{ "restaurants_home.new_restaurant" | translate }}
        </button>
      </div>

      <div class="big-button" (click)="goTo('modifica')">
        <div class="img-button">
          <div class="icon">
            <i class="pi pi-pencil" style="font-size: 2.5rem"></i>
          </div>
        </div>
        <button class="costa-button">
          {{ "restaurants_home.edit_restaurant" | translate }}
        </button>
      </div>

      <div class="big-button" (click)="goTo('slot')">
        <div class="img-button">
          <div class="icon">
            <i class="pi pi-calendar-times" style="font-size: 2.5rem"></i>
          </div>
        </div>
        <button class="costa-button">
          {{ "restaurants_home.manage_slots" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
